import files from '../Assets/Files';
import React, { useState, useEffect, useLayoutEffect } from 'react';
import { TwicImg } from '@twicpics/components/react'
import { produce } from 'immer';

import AwesomeSlider from 'react-awesome-slider';

function HandleImages(obj) {
    let imageText = `${obj.Groupe.dossier}${obj.Groupe.infos.client}${obj.Groupe.infos.direction}${obj.Groupe.infos.year}`
    let imagesNumber = `${obj.Groupe.images.length}`
    const [indexPage, setIndexPage] = useState(1)
    return (
        <div
            data-infos={imageText}
            id={obj.Groupe.header.name.split('/').pop().split('.').shift()}
            key={`${obj.Groupe.dossier}/${obj.Key}`}
            onMouseOver={() => {
                if (obj.columnNumber !== 1) {
                    let infos = document.getElementById('image-infos')
                    let pages = document.getElementById('image-infos-pages')
                    infos.textContent = imageText
                    pages.textContent = imagesNumber
                    pages.hidden = false
                    infos.hidden = false
                }
            }}
            onMouseOut={() => {
                if (obj.columnNumber !== 1) {
                    let infos = document.getElementById('image-infos')
                    let pages = document.getElementById('image-infos-pages')
                    infos.textContent = imageText
                    pages.textContent = imagesNumber
                    pages.hidden = true
                    infos.hidden = true
                }
            }}
        >
            <div onClick={() => {
                let infos = `images_${obj.Groupe.dossier}_${obj.Key}`
                let click = document.getElementById(infos)
                click.hidden = !click.hidden ? true : false
            }}>
                < TwicImg
                    ratio={`${obj.Groupe.header.ratio}`}
                    src={`bro/${obj.Groupe.header.name}`}
                    className="miniature"
                ></TwicImg>
            </div>
            <div id={`images_${obj.Groupe.dossier}_${obj.Key}`} className="image_full_screen" hidden >
                <AwesomeSlider organicArrows={false} onTransitionEnd={(el) => { setIndexPage(el.currentIndex + 1) }}>
                    {obj.Groupe.images.map((image, key) => {
                        return (
                            <div
                                data-src={process.env.PUBLIC_URL + `Images/${image.name}`}
                                key={`${image.name}_${key}`}
                            />
                        )
                    })}
                </AwesomeSlider>
                <span className="arrow-left"></span>
                <span className="arrow-right"></span>
                <div className="page" id={`pages_${obj.Groupe.dossier}_${obj.Key}`}>{indexPage}/{obj.Groupe.images.length}</div>
                <div className="close_div" onClick={() => {
                    let infos = `images_${obj.Groupe.dossier}_${obj.Key}`
                    let click = document.getElementById(infos)
                    click.hidden = !click.hidden ? true : false
                }}>
                    <div className="close close_zoom" ></div>
                </div>
            </div >
        </div >
    );
}

const List = props => {

    const [list, setList] = useState([])
    const [columnNumber, setColumnNumber] = useState()
    const [altInfos, setAltInfos] = useState('')

    useEffect(() => {
        if (altInfos) {
            let el = document.getElementById('image-infos')
            let text = document.getElementById(altInfos)
            el.textContent = text.dataset.infos
            el.hidden = false
        }
    }, [altInfos])

    // recalculate the number of columns based on the page size
    const updateWindowSize = () => {
        let size = window.innerWidth
        let y = size < 901 ? 1 : size < 1200 ? 2 : size < 2000 ? 3 : size < 4000 ? 4 : 4
        setColumnNumber(y)
    }
    // scroll event for smartphone titles
    const handleScroll = (event) => {
        let scrollElement = document.elementFromPoint(window.innerWidth / 2, window.innerHeight / 2)
        if (scrollElement && scrollElement.previousSibling && scrollElement.previousSibling.nodeName.toLowerCase() === 'img') {
            const test = produce(altInfos, draft => {
                draft = scrollElement.previousSibling.alt
                return draft
            })
            !altInfos && setAltInfos(test)
            test !== altInfos && setAltInfos(test)
        }
    }

    useEffect(() => {
        if (props.selection && columnNumber) {
            const getNewList = async () => {
                // get the filters and create a new list
                let promise = new Promise((res) => {
                    setList([])
                    let count = 0
                    // Array.from to create 2 differents instances, otherwise you will get x times the same array...
                    let newList = Array.from({ length: columnNumber }, () => [])
                    files.map(x => x.filters
                        .filter(y => y === props.selection)
                        .map(() => {
                            newList[count].push(x)
                            count = count > columnNumber - 2 ? 0 : count += 1
                            return true
                        }))
                    res(newList)
                })
                promise.then(res => {
                    setList(res)
                })
            }
            getNewList()
        }
    }, [columnNumber, props.selection])

    useLayoutEffect(() => {
        window.addEventListener('resize', updateWindowSize);
        if (window.innerWidth < 901) {
            let hiddenFilters = document.getElementById('filters')
            hiddenFilters.hidden = true
            window.addEventListener('scroll', handleScroll);
        }
        updateWindowSize();
        return () => {
            window.removeEventListener('resize', updateWindowSize)
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])

    return (
        <>
            <div className="images-flex">
                {list.map((k, akey) => {
                    return (
                        < div key={akey} className="columns" >
                            {k.map((groupe, bkey) => <HandleImages Groupe={groupe} Key={bkey} columnNumber={columnNumber} />)}
                        </div>
                    )
                })}
            </div>
        </>
    );
};

export default List;
